import { render, staticRenderFns } from "./OrderStep.vue?vue&type=template&id=3807e21c&scoped=true&"
import script from "./OrderStep.vue?vue&type=script&lang=js&"
export * from "./OrderStep.vue?vue&type=script&lang=js&"
import style0 from "./OrderStep.vue?vue&type=style&index=0&id=3807e21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3807e21c",
  null
  
)

export default component.exports